/* eslint-disable max-len */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

const Subsidy = (props) => (
  <SvgIcon viewBox="0 0 512 512" id="Layer_1" {...props}>
    <g transform="translate(0, 512) scale(0.1, -0.1)">
      <path
        d="M705 4606 c-40 -17 -84 -63 -101 -103 -11 -26 -14 -135 -14 -543 0
        -550 0 -552 53 -608 47 -51 70 -56 260 -60 149 -3 186 -1 222 13 52 19 110 80
        120 124 7 31 8 32 53 29 45 -3 49 -6 151 -118 58 -64 162 -179 231 -256 l125
        -140 3 -84 c9 -325 225 -626 530 -737 462 -170 967 100 1082 580 11 45 20 115
        20 156 0 66 2 72 18 66 88 -38 110 -41 177 -24 56 14 131 79 156 134 24 52 25
        150 2 207 -24 61 -182 342 -244 435 -76 113 -178 240 -245 303 -164 155 -433
        354 -580 428 -141 72 -425 96 -959 82 -187 -5 -379 -12 -427 -14 l-86 -5 -12
        30 c-19 46 -48 78 -91 99 -34 18 -58 20 -226 20 -133 -1 -197 -5 -218 -14z
        m407 -123 c17 -15 18 -45 18 -521 0 -456 -2 -507 -17 -524 -14 -16 -34 -18
        -194 -18 -172 0 -178 1 -193 22 -14 20 -16 86 -16 520 0 485 1 499 20 518 18
        18 33 20 192 20 145 0 174 -3 190 -17z m1353 -128 c183 -30 237 -55 451 -207
        333 -238 499 -434 719 -851 42 -79 57 -118 57 -150 2 -128 -124 -178 -213 -84
        -16 18 -96 126 -177 240 l-147 208 -215 116 c-247 134 -302 152 -471 160 -287
        14 -468 -96 -469 -283 0 -103 29 -178 153 -390 73 -124 76 -193 10 -220 -46
        -20 -98 -11 -155 25 -25 16 -131 126 -244 252 -109 123 -240 266 -290 318
        l-91 95 -62 4 -61 4 0 378 0 378 93 7 c386 27 952 27 1112 0z m-172 -715 c-34
        -15 -81 -41 -105 -57 -69 -47 -72 -48 -59 -25 18 33 68 69 118 85 106 34 123
        33 46 -3z m578 -114 c202 -105 193 -98 312 -265 124 -175 137 -210 137 -376 0
        -124 -16 -192 -76 -313 -37 -76 -61 -109 -127 -176 -128 -128 -266 -191 -447
        -203 -338 -21 -637 196 -721 524 -27 106 -27 107 21 83 61 -31 136 -42 196
        -30 59 13 124 62 144 110 10 23 17 29 29 24 36 -17 128 -16 162 1 94 47 141
        141 119 234 -37 157 -231 214 -346 102 -33 -33 -35 -34 -49 -15 -8 10 -31 52
        -52 93 l-38 74 45 38 c60 53 209 125 295 143 47 11 105 14 179 12 l110 -4 107
        -56z m-391 -371 c50 -54 15 -145 -56 -145 -46 0 -63 9 -79 41 -22 42 -18 67
        14 100 38 38 88 40 121 4z"
      />
      <path
        d="M2607 2913 c-364 -365 -378 -379 -375 -413 3 -37 34 -62 67 -53 10 2
        187 174 394 382 269 269 377 383 377 399 0 28 -34 62 -62 62 -16 0 -130 -108
        -401 -377z"
      />
      <path
        d="M2835 2841 c-172 -44 -223 -243 -91 -358 131 -116 337 -23 336 151
        -1 134 -124 238 -245 207z m103 -143 c31 -30 30 -91 -3 -123 -34 -35 -78 -33
        -116 4 -83 84 32 199 119 119z"
      />
      <path
        d="M923 2024 c-63 -30 -108 -80 -123 -135 -26 -96 9 -150 217 -335 919
        -818 1161 -954 1698 -954 72 0 239 7 371 15 133 8 330 17 438 21 178 6 196 6
        196 -9 0 -9 19 -37 43 -61 58 -61 94 -69 302 -64 191 3 211 9 269 81 l31 39 0
        541 0 542 -25 38 c-15 22 -45 47 -74 62 -48 24 -58 25 -227 25 -196 0 -223 -6
        -277 -62 -18 -18 -38 -50 -44 -73 -6 -22 -13 -42 -15 -44 -1 -2 -63 55 -137
        127 -151 146 -222 190 -356 218 -88 19 -347 14 -614 -11 -183 -17 -241 -37
        -300 -107 -61 -71 -83 -183 -52 -270 l14 -38 -72 0 c-39 0 -90 5 -113 10 -24
        6 -219 106 -435 222 -216 117 -415 220 -443 230 -32 11 -80 17 -135 17 -70 0
        -94 -4 -137 -25z m222 -105 c22 -6 222 -109 445 -230 311 -168 418 -221 460
        -228 52 -9 648 -32 829 -31 64 0 89 4 103 17 21 19 23 52 4 78 -12 17 -35 20
        -227 27 -358 12 -335 10 -371 46 -27 26 -32 40 -36 89 -3 48 0 64 20 92 41 62
        72 72 251 86 600 48 639 39 882 -196 121 -117 148 -139 174 -139 l31 0 0 -385
        0 -385 -42 0 c-24 0 -126 -4 -228 -9 -602 -30 -779 -35 -892 -22 -401 46 -652
        204 -1449 914 -184 163 -205 191 -172 235 35 47 130 65 218 41z m3083 -229
        l22 -21 0 -504 0 -504 -26 -20 c-24 -19 -40 -21 -184 -21 -144 0 -160 2 -184
        21 l-26 20 0 505 c0 491 1 505 20 524 18 18 33 20 188 20 155 0 170 -2 190
        -20z"
      />
    </g>
  </SvgIcon>
);

export default Subsidy;
